import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Text,
  Link as ChakraLink,
} from '@chakra-ui/react';

import { FiLogOut } from 'react-icons/fi';

import {
  IconButton,
  Avatar,
  Box,
  CloseButton,
  Flex,
  HStack,
  VStack,
  Icon,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
  BoxProps,
  FlexProps,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import {
  FiHome,
  FiTrendingUp,
  FiCompass,
  FiStar,
  FiSettings,
  FiMenu,
  FiBell,
  FiChevronDown,
} from 'react-icons/fi';

import { useToast } from '@chakra-ui/react';

// Components
import Sidebar from '../Nav/Sidebar';
import Backdrop from '../Elements/Backdrop';
// Assets
import LogoIcon from '../../assets/svg/Logo';
import BurgerIcon from '../../assets/svg/BurgerIcon';
import Login from '../Login';

import axios from 'axios';
import Cookies from 'js-cookie';

export default function ProfileModel(){
  const bgColor = useColorModeValue('white', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const navigate = useNavigate();

  const toast = useToast();
  const payload = Cookies.get('payload');

  const [userData, setData] = useState('');

  const handleSelected = async () => {
    // const res = await axios
    //   .post('https://globalizer-api.onrender.com/api/user/logout', {
    //     token: localStorage.getItem('token'),
    //   })
    //   .then((res) => {
    //     return res;
    //   })
    //   .catch((err) => console.log(err));
    Cookies.remove('payload')
    navigate('/')
    toast({
      title: 'Logged out Successfully',
      description: 'You have successfully logged out.',
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
  };

  useEffect(() => {
    axios
      .get('https://glb-api.onrender.com/api/user/details', {withCredentials : true})
      .then((res) => {
        console.log(res.data);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
        // setError('Failed to fetch the details right now.')
      });
  }, []);


    return (
        <Flex alignItems={'center'}>
                  <Menu>
                    <MenuButton
                      py={2}
                      transition="all 0.3s"
                      _focus={{ boxShadow: 'none' }}
                    >
                      <HStack>
                        <Avatar
                          size={'md'}
                          src={
                            'https://ih1.redbubble.net/image.4909470396.2618/st,small,507x507-pad,600x600,f8f8f8.jpg'
                          }
                        />
                        <VStack
                          display={{ base: 'none', md: 'flex' }}
                          alignItems="flex-start"
                          spacing="1px"
                          ml="2"
                        >
                          <Text fontSize="sm">{userData?.firstName + " " + userData?.lastName}</Text>
                          <Text fontSize="xs" color="gray.600">
                            User
                          </Text>
                        </VStack>
                        <Box display={{ base: 'none', md: 'flex' }}>
                          <FiChevronDown />
                        </Box>
                      </HStack>
                    </MenuButton>
                    <MenuList bg={bgColor} borderColor={borderColor}>
                      <RouterLink to="/trialdash/authentication">
                        <MenuItem>Profile</MenuItem>
                      </RouterLink>

                      <RouterLink to="/trialdash/settings">
                        <MenuItem>My Dashboard</MenuItem>
                      </RouterLink>

                      <MenuDivider />

                      <MenuItem onClick={handleSelected}>
                        <HStack>
                          <FiLogOut color="red.100" />
                          <Text color="red" ml="2">
                            Sign out
                          </Text>
                        </HStack>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Flex>
    )
}